import { Component } from "react";
import Table from 'react-bootstrap/Table';


class CharacteristicsCategoriesTable extends Component {
    static Title = "Characteristics of the severity of hearing loss categories"
    render() {
        return (
            <Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th></th>              
                    <th>Moderate</th>              
                    <th>Severe</th>              
                    <th>Severe to profound</th>              
                    <th>Profound (90 to 100)</th>              
                    <th>Profound (100+)</th>              
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Subjects (#)</td>
                    <td>67</td>
                    <td>431</td>
                    <td>296</td>
                    <td>247</td>
                    <td>241</td>
                  </tr>
                </tbody>
                <thead className='smoke30-bg'>
                  <tr>
                    <th colSpan={6} className="text-center">Pure Tone Average (dBHL)</th>
                  </tr>
                </thead>  
                <tbody>
                  <tr>
                    <td>PTA Category Lower</td>
                    <td>40</td>
                    <td>60</td>
                    <td>80</td>
                    <td>90</td>
                    <td>100</td>
                  </tr>
                  <tr>
                    <td>PTA Category Upper</td>
                    <td>60</td>
                    <td>80</td>
                    <td>90</td>
                    <td>100</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>PTA Median</td>
                    <td>54.25</td>
                    <td>72.5</td>
                    <td>85</td>
                    <td>93.75</td>
                    <td>106.5</td>
                  </tr>                                    
                </tbody>
                <thead className='smoke30-bg'>
                  <tr>
                    <th colSpan={6} className="text-center">Preoperative aided CNC word score (%)</th>
                  </tr>
                </thead>  
                <tbody>
                  <tr>
                    <td>CNC Lower</td>
                    <td>9.494</td>
                    <td>12</td>
                    <td>8</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>CNC Upper</td>
                    <td>69.012</td>
                    <td>44</td>
                    <td>36</td>
                    <td>26</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>CNC Median</td>
                    <td>40</td>
                    <td>30</td>
                    <td>22</td>
                    <td>12</td>
                    <td>0</td>
                  </tr>                                    
                </tbody> 
                <thead className='smoke30-bg'>
                  <tr>
                    <th colSpan={6} className="text-center">Preoperative binaural aided CNC word score (%)</th>
                  </tr>
                </thead>  
                <tbody>
                  <tr>
                    <td>CNC Median</td>
                    <td>51</td>
                    <td>42</td>
                    <td>35</td>
                    <td>26</td>
                    <td>15</td>
                  </tr>
                </tbody>
                <thead className='smoke30-bg'>
                  <tr>
                    <th colSpan={6} className="text-center">Duration of hearing loss (years)</th>
                  </tr>
                </thead>  
                <tbody>
                  <tr>
                    <td>Duration hearing loss</td>
                    <td>20</td>
                    <td>23</td>
                    <td>23</td>
                    <td>27</td>
                    <td>29</td>
                  </tr>
                  <tr>
                    <td>Duration severe hearing loss</td>
                    <td>8.43</td>
                    <td>9.62</td>
                    <td>9.62</td>
                    <td>11.14</td>
                    <td>11.9</td>
                  </tr>                                  
                </tbody>
                <thead className='smoke30-bg'>
                  <tr>
                        <th colSpan={6} className="text-center">Preoperative unaided air conduction audiogram (dBHL)</th>
                  </tr>
                </thead>  
                <tbody>
                  <tr>
                    <td>125 Hz</td>
                    <td>36.01</td>
                    <td>37.15</td>
                    <td>39.78</td>
                    <td>50.29</td>
                    <td>67.41</td>
                  </tr>
                  <tr>
                    <td>250 Hz</td>
                    <td>34.19</td>
                    <td>40.81</td>
                    <td>46.14</td>
                    <td>58.63</td>
                    <td>78.23</td>
                  </tr>                  
                  <tr>
                    <td>500 Hz</td>
                    <td>34.71</td>
                    <td>46.12</td>
                    <td>54.11</td>
                    <td>67.53</td>
                    <td>87.93</td>
                  </tr>                  
                  <tr>
                    <td>750 Hz</td>
                    <td>37.57</td>
                    <td>53.07</td>
                    <td>63.71</td>
                    <td>76.98</td>
                    <td>96.50</td>
                  </tr>                  
                  <tr>
                    <td>1000 Hz</td>
                    <td>42.86</td>
                    <td>62.80</td>
                    <td>76.68</td>
                    <td>88.69</td>
                    <td>105.07</td>
                  </tr>                  
                  <tr>
                    <td>1500 Hz</td>
                    <td>51.84</td>
                    <td>73.27</td>
                    <td>89.04</td>
                    <td>98.58</td>
                    <td>110.56</td>
                  </tr>                  
                  <tr>
                    <td>2000 Hz</td>
                    <td>60.65</td>
                    <td>89.90</td>
                    <td>99.23</td>
                    <td>106.38</td>
                    <td>114.84</td>
                  </tr>                  
                  <tr>
                    <td>3000 Hz</td>
                    <td>71.23</td>
                    <td>91.57</td>
                    <td>107.15</td>
                    <td>112.27</td>
                    <td>117.90</td>
                  </tr>                  
                  <tr>
                    <td>4000 Hz</td>
                    <td>79.66</td>
                    <td>98.57</td>
                    <td>112.26</td>
                    <td>116.20</td>
                    <td>120.00</td>
                  </tr>                  
                  <tr>
                    <td>6000 Hz</td>
                    <td>87.15</td>
                    <td>104.12</td>
                    <td>114.65</td>
                    <td>118.10</td>
                    <td>120.99</td>
                  </tr>                  
                  <tr>
                    <td>8000 Hz</td>
                    <td>93.72</td>
                    <td>108.22</td>
                    <td>114.31</td>
                    <td>117.97</td>
                    <td>120.88</td>
                  </tr> 
                </tbody>
            </Table>
            );
    }
}
export default CharacteristicsCategoriesTable 